import React from "react";
import { toast } from "react-toastify";
import Joi from "joi-browser";
import { Button, Form } from "react-bootstrap";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import { FiSearch } from "react-icons/fi";
import { IconContext } from "react-icons";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { getFinancialReport } from "../services/dashboardService";
import { formatNumber } from "../services/util";
import PageLoading from "./common/pageLoading";
import FormComponent from "./common/formComponent";

class FinancialReport extends FormComponent {
  state = {
    data: {
      year: "",
    },
    reports: [],
    loading: "",
    errors: {},
  };

  schema = {
    year: Joi.number().required().label("Year"),
  };

  doSubmit = async () => {
    this.setState({ loading: true });

    const { year } = this.state.data;
    await this.getFinancialReport(year);
  };

  // async componentDidMount() {
  //   const { year } = this.state.data;
  //   await this.getFinancialReport(year);
  // }

  async getFinancialReport(year) {
    try {
      let reports = [];
      const { data } = await getFinancialReport(year);
      reports = data;
      this.setState({ reports });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { reports, errors, loading } = this.state;
    const { year } = this.state.data;

    return (
      <React.Fragment>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <h5>Financial Report</h5>
            </div>
            <div className="card-body">
              <span className="card-text">
                <Form onSubmit={this.handleSubmit} className="mb-4">
                  <div class="container">
                    <div className="row search-bar">
                      <div className="col-md search-bar-col">
                        <Form.Group controlId="year">
                          <Form.Control
                            type="text"
                            name="year"
                            value={year}
                            autoFocus
                            autoComplete="off"
                            onChange={this.handleChange}
                            placeholder="Enter financial report year"
                            className="search-field"
                          />
                          {errors.year && <span className="text-danger">{errors.year}</span>}
                        </Form.Group>
                      </div>

                      <div className="search-bar-col">
                        <Form.Group>
                          <Button className="search-button" type="submit" disabled={this.validate() || loading}>
                            <IconContext.Provider value={{ color: "black", className: "global-class-name" }}>
                              <FiSearch />
                            </IconContext.Provider>
                          </Button>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Form>
                {loading && <PageLoading loading={loading} />}
                {!loading && reports.length === 0 && <span>No Reports to Display</span>}
                {!loading && reports.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Month</StyledTableCell>
                          <StyledTableCell>Renewals</StyledTableCell>
                          <StyledTableCell>New Services</StyledTableCell>
                          <StyledTableCell>Renewal Total</StyledTableCell>
                          <StyledTableCell>New Service Total</StyledTableCell>
                          <StyledTableCell>Total Sale</StyledTableCell>
                          <StyledTableCell>Total Revenue</StyledTableCell>
                          <StyledTableCell>Expenses</StyledTableCell>
                          <StyledTableCell>Profit</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {reports.map((report) => (
                          <StyledTableRow key={report.month}>
                            <StyledTableCell component="th" scope="row">
                              {report.month}
                            </StyledTableCell>
                            <StyledTableCell>{formatNumber(report.renewalCount)}</StyledTableCell>
                            <StyledTableCell>{formatNumber(report.newServiceCount)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.renewalTotal)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.newServiceTotal)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.saleTotal)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.totalRevenue)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.totalExpenses)}</StyledTableCell>
                            <StyledTableCell>&#8358;{formatNumber(report.profit)}</StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </span>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
}

export default FinancialReport;
